import React, { useEffect } from "react";
import Chart from "chart.js/auto";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';

const RoyaltyReporting = () => {
  useEffect(() => {
    const discChart = document.getElementById("discChart");
    if (discChart) {
      new Chart(discChart, {
        type: "bar",
        data: {
          labels: ["Wrong Rate", "Missing Items", "Min Guarantee", "Late Report", "Other"],
          datasets: [
            {
              data: [17000, 12600, 10700, 0, 2000],
              backgroundColor: ["#EF4444", "#F97316", "#EAB308", "#6B7280", "#6B7280"],
            },
          ],
        },
        options: {
          responsive: true,
          indexAxis: "y",
          plugins: { legend: { display: false } },
          scales: { x: { title: { display: true, text: "Variance ($)" } } },
        },
      });
    }
  }, []);

  return (<div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
    <div className="">
      <div className="flex items-center justify-between mb-6">
        {/* <div>
          <h1 className="text-3xl font-bold text-gray-900">Royalty Reporting & Reconciliation</h1>
          <p className="text-gray-500 mt-1">Import sales reports, match against contract terms, flag discrepancies</p>
        </div> */}

        <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="BarChart" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Royalty Reporting & Reconciliation</h1>
                <p className="text-muted mb-0 small">Import sales reports, match against contract terms, flag discrepancies</p>
              </div>
        </div>  

        <div className="flex gap-2">
          <button className="border px-4 py-2 rounded-lg bg-white">Import Sales Report</button>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">Run Reconciliation</button>
        </div>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-green-500">
          <p className="text-sm text-gray-500">Reports Received</p>
          <p className="text-2xl font-bold">14 / 18</p>
          <p className="text-sm text-yellow-600">4 pending submission</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-blue-500">
          <p className="text-sm text-gray-500">Total Reported Sales</p>
          <p className="text-2xl font-bold">$9.8M</p>
          <p className="text-sm text-gray-400">Q1 2026</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-purple-500">
          <p className="text-sm text-gray-500">Royalties Calculated</p>
          <p className="text-2xl font-bold">$847K</p>
          <p className="text-sm text-green-600">$612K collected</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 border-l-4 border-red-500">
          <p className="text-sm text-gray-500">Discrepancies Found</p>
          <p className="text-2xl font-bold text-red-600">5</p>
          <p className="text-sm text-red-500">$42,300 in question</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6 mb-6">
        {/* Reconciliation Table */}
        <div className="col-span-2 bg-white rounded-xl shadow p-6">
          <h5 className="text-lg font-semibold mb-4">Sales Report Reconciliation</h5>
            <div className="overflow-x-auto">
              <table className="w-full text-sm min-w-[600px]">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="p-3 text-left">Licensee</th>
                    <th className="p-3 text-right">Reported Sales</th>
                    <th className="p-3 text-right">Expected Royalty</th>
                    <th className="p-3 text-right">Paid</th>
                    <th className="p-3 text-right">Variance</th>
                    <th className="p-3 text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="p-3">Summit Ridge Merch</td>
                    <td className="p-3 text-right">$2,850,000</td>
                    <td className="p-3 text-right">$228,000</td>
                    <td className="p-3 text-right">$228,000</td>
                    <td className="p-3 text-right text-green-600">$0</td>
                    <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Matched</span></td>
                  </tr>
                  <tr className="border-t bg-red-50">
                    <td className="p-3">Golden State Apparel</td>
                    <td className="p-3 text-right">$3,400,000</td>
                    <td className="p-3 text-right">$238,000</td>
                    <td className="p-3 text-right">$221,000</td>
                    <td className="p-3 text-right text-red-600 font-semibold">-$17,000</td>
                    <td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs">Underpaid</span></td>
                  </tr>
                  <tr className="border-t">
                    <td className="p-3">Horizon Peak Retail</td>
                    <td className="p-3 text-right">$1,200,000</td>
                    <td className="p-3 text-right">$120,000</td>
                    <td className="p-3 text-right">$120,000</td>
                    <td className="p-3 text-right text-green-600">$0</td>
                    <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Matched</span></td>
                  </tr>
                  <tr className="border-t bg-red-50">
                    <td className="p-3">Dreamlight Studios</td>
                    <td className="p-3 text-right">$2,100,000</td>
                    <td className="p-3 text-right">$189,000</td>
                    <td className="p-3 text-right">$176,400</td>
                    <td className="p-3 text-right text-red-600 font-semibold">-$12,600</td>
                    <td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs">Underpaid</span></td>
                  </tr>
                  <tr className="border-t bg-yellow-50">
                    <td className="p-3">NovaTech Games</td>
                    <td className="p-3 text-right">$95,000</td>
                    <td className="p-3 text-right">$25,000</td>
                    <td className="p-3 text-right">—</td>
                    <td className="p-3 text-right text-yellow-600">Pending</td>
                    <td className="p-3 text-center"><span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs">Min Guarantee</span></td>
                  </tr>
                  <tr className="border-t bg-gray-50">
                    <td className="p-3 text-gray-400">Pacific Coast Toys</td>
                    <td className="p-3 text-right text-gray-400">—</td>
                    <td className="p-3 text-right text-gray-400">—</td>
                    <td className="p-3 text-right text-gray-400">—</td>
                    <td className="p-3 text-right text-gray-400">—</td>
                    <td className="p-3 text-center"><span className="bg-gray-100 text-gray-500 px-2 py-1 rounded-full text-xs">No Report</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>

        {/* Discrepancy Details */}
        <div className="space-y-4">
          <div className="bg-white rounded-xl shadow p-5">
            <h5 className="font-semibold mb-3">Discrepancy Analysis</h5>
            <canvas id="discChart" height="200"></canvas>
          </div>
          <div className="bg-white rounded-xl shadow p-5">
            <h5 className="font-semibold mb-3">Top Issues</h5>
            <div className="space-y-3 text-sm">
              <div className="border-l-4 border-red-500 pl-3">
                <p className="font-medium">Golden State — Wrong rate applied</p>
                <p className="text-xs text-gray-500">Used 6.5% instead of 7%. Contract ref: Section 4.2</p>
              </div>
              <div className="border-l-4 border-red-500 pl-3">
                <p className="font-medium">Dreamlight — Missing product category</p>
                <p className="text-xs text-gray-500">Digital downloads not included in report</p>
              </div>
              <div className="border-l-4 border-yellow-500 pl-3">
                <p className="font-medium">NovaTech — Below minimum guarantee</p>
                <p className="text-xs text-gray-500">Sales $95K, minimum $25K applies regardless</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Import History */}
      <div className="bg-white rounded-xl shadow p-6">
        <h5 className="text-lg font-semibold mb-4">Recent Report Imports</h5>
        <div className="space-y-2">
          <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center text-green-600 text-lg">&#10003;</div>
            <div className="flex-1"><p className="font-medium text-sm">Summit_Ridge_Q1_2026_Sales.xlsx</p><p className="text-xs text-gray-500">Imported Mar 15, 2026 | 1,245 line items | Auto-matched to contract</p></div>
            <span className="text-sm text-green-600">Reconciled</span>
          </div>
          <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center text-green-600 text-lg">&#10003;</div>
            <div className="flex-1"><p className="font-medium text-sm">Golden_State_Apparel_Sales_Jan-Mar26.csv</p><p className="text-xs text-gray-500">Imported Mar 18, 2026 | 3,891 line items | 2 discrepancies found</p></div>
            <span className="text-sm text-red-600">Issues Found</span>
          </div>
          <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg">
            <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center text-yellow-600 text-lg">&#8635;</div>
            <div className="flex-1"><p className="font-medium text-sm">Dreamlight_Studios_Q1_Report.pdf</p><p className="text-xs text-gray-500">Imported Mar 20, 2026 | AI-extracted 892 line items from PDF | Under review</p></div>
            <span className="text-sm text-yellow-600">Reviewing</span>
          </div>
        </div>
      </div>
    </div></div></div></div></div>
  );
};

export default RoyaltyReporting;
